module.exports = __webpack_public_path__ + "static/img/inviteBack.9cb6d331.jpg";